import lozad from 'lozad';

import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

import addReadMore from './PdpReadMore.script';

const pdpDetailAccordionBootstrap = async () => {
    const headings = document.querySelectorAll<HTMLElement>('.field-wrapper');
    headings.forEach((heading) => {
        if (heading) {
            heading
                .querySelector<HTMLElement>('.field-wrapper__accordion-heading')
                ?.addEventListener('click', async () => {
                    const items = heading.querySelector<HTMLElement>(':scope > .field-wrapper__content-wrapper');
                    const iconDiv = heading.querySelector<HTMLElement>('.field-wrapper__accordion-heading__icon');
                    const link = heading.querySelector<HTMLElement>('.field-wrapper__accordion-heading__text');

                    if (items && iconDiv) {
                        if (items.classList.contains('AccordionHidden')) {
                            link.classList.add('open');
                            iconDiv.classList.remove('field-wrapper__accordion-heading__icon--plus-icon');
                            iconDiv.classList.add('field-wrapper__accordion-heading__icon--minus-icon');
                            items.classList.remove('AccordionHidden');
                        } else {
                            link.classList.remove('open');
                            iconDiv.classList.add('field-wrapper__accordion-heading__icon--plus-icon');
                            iconDiv.classList.remove('field-wrapper__accordion-heading__icon--minus-icon');
                            items.classList.add('AccordionHidden');
                        }
                    }
                });
        }
    });
};

pdpDetailAccordionBootstrap();
const observer = lozad('.lazyLoadDetails', {
    load: function (el) {
        const headings = document.querySelectorAll<HTMLElement>('.field-wrapper');
        headings.forEach((heading) => {
            if (heading) {
                const itemIndex = parseInt(heading.dataset.index);
                const itemNumber = heading.dataset.itemnumber;
                const fetchSectionData = async () => {
                    const headers = {
                        'Content-Type': 'application/json',
                        'cache-control': 'no-cache',
                        currentdatetime: new Cookie().CurrentDate,
                    };
                    const base = '/api/v3/';
                    const lang = new Cookie().Language.substring(0, 2) || 'en';
                    const infoTabUrl = `${base}${lang}/products/${itemNumber}/sections/${itemIndex}`;
                    if (itemIndex == 0) {
                        //add read more button to product overview accordion
                        const overviewTarget = document.getElementById('contentTab' + itemIndex);
                        addReadMore(overviewTarget);
                    }
                    if (itemIndex > 0) {
                        try {
                            const tabData = await http.get(infoTabUrl, {
                                headers: headers,
                                transformRequest: (data, headers) => {
                                    delete headers.Authorization;
                                    return data;
                                },
                            });
                            //@ts-ignore
                            const content =
                                tabData.data.Contents[0].Content != null ? tabData.data.Contents[0].Content : '';
                            const target = document.getElementById('contentTab' + itemIndex);
                            if (target && content) {
                                heading.dataset.loaded = 'true';
                                target.insertAdjacentHTML('beforeend', content);
                                //add readmore script
                                setTimeout(() => {
                                    addReadMore(target);
                                }, 500);
                            }
                        } catch (e) {
                            return null;
                        }
                    }
                };
                fetchSectionData();
            }
        });
    },
});
observer.observe();
